import Vue from 'vue'
import Router from 'vue-router'
import HymnbooksApp from './components/HymnbooksApp.vue'
import HymnbooksPrivacyPolicy from './components/HymnbooksPrivacyPolicy.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'root',
            component: HymnbooksApp
        },
        {
            path: '/hymnbooks',
            name: 'hymnbooks_app',
            component: HymnbooksApp
        },
        {
            path: '/hymnbooks/privacy',
            name: 'hymnbooks_privacy_policy',
            component: HymnbooksPrivacyPolicy
        }
    ]
})

export default router
